import React from 'react'

import {DatePicker} from '@mantine/dates'

const DatePickerComponent = ({value, onChange, allowSingleDate = false}) => {
  return (
    <DatePicker
      type="range"
      value={value}
      onChange={date_range => {
        onChange(date_range)
      }}
      allowSingleDateInRange={allowSingleDate}
    />
  )
}

export default DatePickerComponent
